import { Pipe, PipeTransform } from '@angular/core';

import { hasUserStation } from '../constants/constants';

@Pipe({ name: 'countUserProductStations', standalone: true })
export class CountUserProductStationsPipe implements PipeTransform {
  transform(
    section: string,
    areAllProductsSelected: any,
    productName: string,
    options = {},
    productList: any,
    userServiceUserData: any
  ): number {
    let count = 0;
    if (options.hasOwnProperty('productName')) {
      if (
        productList.hasOwnProperty(productName) &&
        productList[productName].hasOwnProperty(options['productType'])
      ) {
        for (const product of productList[productName][
          options['productType']
        ]) {
          if (
            hasUserStation(
              userServiceUserData,
              product,
              section,
              areAllProductsSelected
            )
          ) {
            count++;
          }
        }
      }
    } else if (options.hasOwnProperty('eppParameterset')) {
      const parameterset = options['eppParameterset'];
      const res =
        options['eppResolution'].days + '_' + options['eppResolution'].hourly;
      if (
        productList.hasOwnProperty(productName) &&
        productList[productName].hasOwnProperty(parameterset) &&
        productList[productName][parameterset].hasOwnProperty(res)
      ) {
        for (const product of productList[productName][parameterset][res]) {
          if (
            hasUserStation(
              userServiceUserData,
              product,
              section,
              areAllProductsSelected
            )
          ) {
            count++;
          }
        }
      }
    } else if (options.hasOwnProperty('epp')) {
      const parameterset = Object.keys(productList.epp)[0];
      if (parameterset && productList.epp.hasOwnProperty(parameterset)) {
        const res = Object.keys(productList.epp[parameterset])[0];
        if (
          productList.hasOwnProperty(productName) &&
          productList[productName].hasOwnProperty(parameterset) &&
          productList[productName][parameterset].hasOwnProperty(res)
        ) {
          for (const product of productList[productName][parameterset][res]) {
            if (
              hasUserStation(
                userServiceUserData,
                product,
                section,
                areAllProductsSelected
              )
            ) {
              count++;
            }
          }
        }
      }
    } else {
      if (productList.hasOwnProperty(productName)) {
        if (Array.isArray(productList[productName])) {
          for (const product of productList[productName]) {
            if (
              hasUserStation(
                userServiceUserData,
                product,
                section,
                areAllProductsSelected
              )
            ) {
              count++;
            }
          }
        } else {
          for (const productType in productList[productName]) {
            for (const product of productList[productName][productType]) {
              if (
                hasUserStation(
                  userServiceUserData,
                  product,
                  section,
                  areAllProductsSelected
                )
              ) {
                count++;
              }
            }
          }
        }
      }
    }
    return count;
  }
}
